import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import PriceVatDisclaimer from 'common/PriceVatDisclaimer';


const rows = [
  { product: 'Alianza de Autoridad', detail: 'Vocería de Angélica Lugo, entrevistas médicas, inserts en clips y presencia de logo en mini-site', investment: '$450' },
  { product: 'Agencia Creativa & Redes', detail: '8 piezas de video mensuales (UGC + Médicos) y dinamización activa de RRSS', investment: '$300' },
  { product: 'Estrategia TNO Digest', detail: '4 artículos de fondo mensuales (1 semanal) con enfoque SEO', investment: '$100' },
  { product: 'Omnicanalidad TNO', detail: 'Cuñas, banners y rotativa de micro-audiovisuales. Bonificación: Banner en página principal de TNO', investment: '$100' },
];

const InvestmentSummary = () => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          color="primary"
          align="center"
        >
          Resumen
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h4"
          gutterBottom
          align="center"
          color="primary"
        >
          Arquitectura de Inversión (Lanzamiento 360°)
        </Box>
      </Box>
      <TableContainer
        component={Paper}
        elevation={2}
        sx={{ maxWidth: 720, mx: 'auto', borderRadius: 2 }}
      >
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: theme.palette.primary.main }}>
              <TableCell sx={{ color: 'white', fontWeight: 700 }}>Concepto de Servicio</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: 700 }}>Descripción del Impacto</TableCell>
              <TableCell align="right" sx={{ color: 'white', fontWeight: 700 }}>
                Inversión Mensual
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, i) => (
              <TableRow key={i} hover>
                <TableCell>{row.product}</TableCell>
                <TableCell>{row.detail}</TableCell>
                <TableCell align="right">{row.investment}</TableCell>
              </TableRow>
            ))}
            <TableRow sx={{ bgcolor: theme.palette.primary.main }}>
              <TableCell colSpan={2} sx={{ color: 'white', fontWeight: 700 }}>
                INVERSIÓN MENSUAL TOTAL
              </TableCell>
              <TableCell align="right" sx={{ color: 'white', fontWeight: 700 }}>
                $950
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <Box sx={{ maxWidth: 720, mx: 'auto', mt: 2, textAlign: 'center' }}>
        <Typography variant="body2" color="textSecondary">
          Estrategia completa de posicionamiento y mercadeo. © TNO Network 2026 | The Content Evolution.
        </Typography>
      </Box>
      <PriceVatDisclaimer />
    </Box>
  );
};

export default InvestmentSummary;
